import { FC } from 'react'

export const PasteIcon: FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg
		fill="currentColor"
		height="64px"
		width="64px"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 32 32"
		xmlSpace="preserve"
	>
		<g id="bg" strokeWidth="0"></g>
		<g id="tracer" strokeLinecap="round" strokeLinejoin="round"></g>
		<g id="icon">
			<g>
				<path d="M12,6h8c0.6,0,1-0.4,1-1V3c0-1.7-1.3-3-3-3h-4c-1.7,0-3,1.3-3,3v2C11,5.6,11.4,6,12,6z"></path>
				<path d="M23,10c0.4,0,0.8,0.1,1.2,0.3l1.5,1.2l1.3,1.3V7c0-2.4-1.8-4.5-4.1-4.9C23,2.4,23,2.7,23,3v2c0,1.7-1.3,3-3,3h-8 c-1.7,0-3-1.3-3-3V3c0-0.3,0-0.6,0.1-0.9C6.8,2.5,5,4.6,5,7v16c0,2.8,2.2,5,5,5h2V13c0-1.7,1.3-3,3-3H23z"></path>{' '}
				<path d="M28.2,20H23c-0.6,0-1-0.4-1-1v-7h-7c-0.6,0-1,0.4-1,1v18c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1v-9.2C30,20.8,29.2,20,28.2,20 z"></path>{' '}
				<polygon points="24,18 29.4,18 24,12.6 "></polygon>
			</g>
		</g>
	</svg>
)
